import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ProviderDate } from '@bagonboard/ui-kit';
import { SERVICE_TYPES, isDestinationService } from '@bagonboard/wiseman';

import getAddress from '../../../../../modules/getAddress';
import * as actions from '../../../../../reducers/Service/actions';
import {
  EditAddress, EditDate, EditInput, EditTime,
} from './components';
import {
  Address,
  DeliveryContainer,
  Info,
  PickupContainer,
  Title,
  Warning,
  withPickupDeliveryStyles,
} from './style';

const {
  TRANSFER,
  SKIP_BAGGAGE_CLAIM,
} = SERVICE_TYPES;
const getTerminalNumber = airport => airport && airport.terminal && airport.terminal.number;

class PickupDelivery extends Component {
  onDeliveryTimeChange = (date) => {
    const { id, updateService } = this.props;

    updateService({ deliveryTime: date.utc().format(), serviceId: id });
  };

  onDeliveryAddressChange = (value) => {
    if (!value) return;

    const { to, id, updateService } = this.props;
    const parsedValue = {
      ...value,
      location: {
        lat: `${value.location.lat}`,
        lng: `${value.location.lng}`,
      },
    };

    updateService({ to: { ...to, ...parsedValue, _id: undefined }, serviceId: id });
  };

  onDeliveryExtraAddressChange = (value) => {
    if (!value) return;

    const { to, id, updateService } = this.props;

    updateService({ to: { ...to, streetExtra: value, _id: undefined }, serviceId: id });
  };

  onPickupAddressChange = (value) => {
    if (!value) return;

    const { from, id, updateService } = this.props;
    const parsedValue = {
      ...value,
      location: {
        lat: `${value.location.lat}`,
        lng: `${value.location.lng}`,
      },
    };

    updateService({ from: { ...from, ...parsedValue, _id: undefined }, serviceId: id });
  };

  onPickupExtraAddressChange = (value) => {
    if (!value) return;

    const { from, id, updateService } = this.props;

    updateService({ from: { ...from, streetExtra: value, _id: undefined }, serviceId: id });
  };

  onPickupTimeChange = (date) => {
    const { id, updateService } = this.props;

    updateService({ pickupTime: date.utc().format(), serviceId: id });
  };

  render() {
    const {
      areas,
      deliverySlot,
      deliveryTime,
      flightInfo,
      from,
      pickupSlot,
      pickupTime,
      to,
      type,
      classes,
    } = this.props;

    const fromLocation = getAddress(from);
    const toLocation = getAddress(to);
    const [{ timezone } = {}] = areas;
    const pickupDate = ProviderDate.utcTimezone(pickupTime, timezone);
    const deliveryDate = ProviderDate.utcTimezone(deliveryTime, timezone);

    let fromAddress;
    let toAddress;

    if (isDestinationService(type)) {
      fromAddress = `${fromLocation.street} T${getTerminalNumber(flightInfo.destination)}`;
      toAddress = `${toLocation.street}, ${toLocation.city}`;
    } else {
      fromAddress = `${fromLocation.street}, ${fromLocation.city}`;
      toAddress = `${toLocation.street} T${getTerminalNumber(flightInfo.origin)}`;
    }

    return (
      <div className={classes.root}>
        <span>
          <Title>Pick-Up</Title>
          <PickupContainer>
            <EditDate
              date={pickupTime}
              onChange={this.onPickupTimeChange}
              editable={type !== SKIP_BAGGAGE_CLAIM}
            >
              {pickupDate.format('DD/MM/YYYY')}
            </EditDate>
            <EditTime
              date={pickupTime}
              timezone={timezone}
              onChange={this.onPickupTimeChange}
              editable={type !== SKIP_BAGGAGE_CLAIM}
            >
              {`${pickupDate.format('HH:mm')} - ${pickupDate.add(pickupSlot, 's').format('HH:mm')}`}
            </EditTime>
            <EditAddress
              area={from.cityCode}
              onChange={this.onPickupAddressChange}
              value={fromLocation.street}
              location={fromLocation.location}
              editable={!isDestinationService(type)}
            >
              { fromAddress
                ? (
                  <Address href={`https://www.google.com/maps/search/${fromAddress}`} target="_blank">
                    {fromAddress}
                  </Address>
                )
                : (
                  <Warning>Not found</Warning>
                )}
            </EditAddress>
            {!isDestinationService(type) && (
            <EditInput
              onChange={this.onPickupExtraAddressChange}
              value={fromLocation.streetExtra}
            >
              { fromLocation.streetExtra
                ? (
                  <Address href={`https://www.google.com/maps/place/${fromLocation.street}}`} target="_blank">
                    {fromLocation.streetExtra}
                  </Address>
                )
                : (
                  <Info>Address details</Info>
                )}
            </EditInput>
            )}
          </PickupContainer>
        </span>
        <span>
          <Title>Delivery</Title>
          <DeliveryContainer>
            <EditDate date={deliveryTime} onChange={this.onDeliveryTimeChange} editable>
              {deliveryDate.format('DD/MM/YYYY')}
            </EditDate>
            <EditTime
              date={deliveryTime}
              timezone={timezone}
              onChange={this.onDeliveryTimeChange}
              editable
            >
              {`${deliveryDate.format('HH:mm')} - ${deliveryDate.add(deliverySlot, 's').format('HH:mm')}`}
            </EditTime>
            <EditAddress
              area={to.cityCode}
              onChange={this.onDeliveryAddressChange}
              value={toAddress}
              location={toLocation.location}
              editable={isDestinationService(type)}
            >
              { toAddress ? (
                <Address href={`https://www.google.com/maps/place/${toAddress}`} target="_blank">
                  {toAddress}
                </Address>
              ) : (
                <Warning>Not found</Warning>
              )}
            </EditAddress>
            {isDestinationService(type) && (
            <EditInput
              onChange={this.onDeliveryExtraAddressChange}
              value={toLocation.streetExtra}
            >
              { toLocation.streetExtra
                ? (
                  <Address href={`https://www.google.com/maps/place/${toLocation.street}}`} target="_blank">
                    {toLocation.streetExtra}
                  </Address>
                )
                : (
                  <Info>Address details</Info>
                )}
            </EditInput>
            )}
          </DeliveryContainer>
        </span>
      </div>
    );
  }
}
PickupDelivery.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
  areas       : PropTypes.arrayOf(PropTypes.shape({})),
  deliverySlot: PropTypes.number,
  deliveryTime: PropTypes.string,
  flightInfo  : PropTypes.shape({
    destination: PropTypes.object,
    origin     : PropTypes.object,
  }),
  from: PropTypes.shape({
    cityCode: PropTypes.object,
  }),
  id        : PropTypes.string,
  pickupSlot: PropTypes.number,
  pickupTime: PropTypes.string,
  to        : PropTypes.shape({
    cityCode: PropTypes.object,
  }),
  type         : PropTypes.string,
  updateService: PropTypes.func,
};
PickupDelivery.defaultProps = {
  areas       : [],
  deliverySlot: 0,
  deliveryTime: '',
  flightInfo  : {
    origin: {
      terminal: {},
    },
  },
  from: {
    street     : '',
    streetExtra: '',
  },
  id        : '',
  pickupSlot: 0,
  pickupTime: '',
  to        : {
    poi: {
      address: {
        street: '',
      },
      name: '',
    },
  },
  type: TRANSFER,
  updateService() {},
};

const mapDispatchToProps = dispatch => ({
  updateService: data => dispatch(actions.updateService(data)),
});

export default compose(
  withPickupDeliveryStyles,
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(PickupDelivery);
